import { Switch, alpha, styled } from '@mui/material';

/**
 * Standard switch toggle to be reused across app.
 * @returns {JSX.Element}
 */
const PrimarySwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(6px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(22px)',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.secondary.main
      }
    }
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: theme.palette.primary.main,
    width: 32,
    height: 32
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    backgroundColor: alpha(theme.palette.primary.main, 0.7),
    borderRadius: 20 / 2
  }
}));

export default PrimarySwitch;
